import { Injectable } from '@angular/core';
import { EventTrackerStrategyResource } from '@infra/trackers';
import { sha256 } from '@shared/utils/sha256';

export interface ISetTrackerUserIdAction {
  run(tracker: 'amplitude', id: string): Promise<void>;
}

@Injectable({ providedIn: 'root' })
export class SetTrackerUserIdAction implements ISetTrackerUserIdAction {
  constructor(private eventTrackerStrategy: EventTrackerStrategyResource) {}

  async run(tracker: 'amplitude', id: string): Promise<void> {
    const strategy = this.eventTrackerStrategy.create(tracker);

    const identifier = await sha256(id.trim().toLowerCase());

    strategy.setUserId?.(identifier);
  }
}
